import { Alert, Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface AuthenticationUnavailableProps {
  readonly items: readonly string[];
}

/**
 * Fail-closed placeholder for identity actions this console cannot perform on its own: password
 * changes, MFA, sign-in, token refresh, and session revocation are all owned by the Cognito
 * identity provider. This component must never render a button that invents an API call for any
 * of these — there is no such endpoint in the current OpenAPI contract.
 */
export function AuthenticationUnavailable({ items }: AuthenticationUnavailableProps) {
  const { t } = useTranslation();
  return (
    <Alert severity="info">
      <Typography variant="body2">{t('profile.identityProvider.managed')}</Typography>
      <Box component="ul" sx={{ m: 0, mt: 1, pl: 2.5 }}>
        {items.map((item) => (
          <Typography component="li" key={item} variant="body2">
            {item}
          </Typography>
        ))}
      </Box>
    </Alert>
  );
}
